import React, { useState } from 'react';
import RequestForSignetApprovalList from './RequestForSignetApprovalList';
import { withRouter } from 'react-router-dom';
import RequestForSignetApprovalFilter from '../RequestForSignetApproval/Filter/RequestForSignetApprovalFilter';
import { numberOfItemsPerPage } from '../../constants/globals.js';

const RequestForSignetApproval = () => {
  const initialStateValues = {
    createdAtFrom: Date.now(),
    createdAtTo: Date.now(),
  };

  const [filters, setFilters] = useState(initialStateValues);
  const [postData, setPostData] = useState(null);
  const [resetData, setResetData] = useState(false);
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(numberOfItemsPerPage);

  return (
    <div className="wrapper-fade-in content-min-height mb-5 mt-2">
      <div className="container">
        <RequestForSignetApprovalFilter
          saveFilters={(filters) => setFilters(filters)}
          initialValues={filters}
          initialStateValues={initialStateValues}
          savePostData={(postData) => setPostData(postData)}
          setResetData={setResetData}
          pageSize={pageSize}
        />
        <RequestForSignetApprovalList
          postData={postData}
          resetData={resetData}
          setResetData={setResetData}
          activePage={activePage}
          pageSize={pageSize}
          setActivePage={setActivePage}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
};

export default withRouter(RequestForSignetApproval);
